import PrivacyPolicy from '#app/components/privacyPolicy/privacyPolicy.tsx'

export default function privacyPolicyPage() {
	return <PrivacyPolicy />
}
